import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import NavBar from './nav-bar'
import SEO from './seo'
import OpenJumpModal from './open-jump-modal'

import '../css/style.css'
import '../css/utilities.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <SEO />
        <NavBar siteTitle={data.site.siteMetadata.title} />
        <div className="bg-grey-lighter pt-12">{children}</div>
        <OpenJumpModal />
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
